<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>ອະນຸມັດການແກ້ໄຂລູກຄ້າທຸລະກິດ</p>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="ຄົ້ນຫາຊື່ບໍລິສັດ"
          single-line
          hide-details
          clearable
          @keyup.enter="fetchData(1)"
          @click:clear="filter = ''; fetchData(1)"
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.customer_id`]="{ item }">
          COM_{{ item.customer_id }}
        </template>
        <template v-slot:[`item.submitter`]="{ item }">
          {{ item.submitter ? item.submitter.name : '' }}
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            small
            text
            color="primary"
            @click="openDetail(item)"
          >
            <v-icon
              small
              left
            >
              mdi-eye
            </v-icon>
            ກວດສອບ
          </v-btn>
        </template>
      </v-data-table>
      <Pagination
        v-if="pagination.total_pages > 1"
        :pagination="pagination"
        :offset="offset"
        @paginate="fetchData()"
      />
    </v-card>

    <v-dialog
      v-model="detailDialog"
      max-width="860px"
    >
      <v-card v-if="selected">
        <v-card-title>
          COM_{{ selected.customer_id }} · {{ selected.company_name }}
        </v-card-title>
        <v-card-subtitle>
          ສົ່ງໂດຍ {{ selected.submitter ? selected.submitter.name : '' }} · {{ selected.created_at }}
          <div v-if="selected.requester_name">
            ຜູ້ປະສານງານຂໍເພີ່ມຂໍ້ມູນ: {{ selected.requester_name }} ({{ selected.requester_department }})
          </div>
          <div
            v-if="selected.conditions"
            style="white-space: pre-line"
          >
            ເງື່ອນໄຂ: {{ selected.conditions }}
          </div>
        </v-card-subtitle>
        <v-card-text>
          <p
            v-if="!detailLoaded"
            class="text--secondary"
          >
            ກຳລັງໂຫຼດ...
          </p>
          <p
            v-else-if="!rows.length"
            class="text--secondary"
          >
            ບໍ່ມີຊ່ອງໃດຕ່າງຈາກຂໍ້ມູນປັດຈຸບັນ.
          </p>
          <v-simple-table
            v-else
            dense
          >
            <thead>
              <tr>
                <th>ຊ່ອງ</th>
                <th>ຂໍ້ມູນປັດຈຸບັນ</th>
                <th>ແກ້ເປັນ</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in rows"
                :key="row.field"
              >
                <td class="font-weight-bold">
                  {{ row.label }}
                </td>
                <td class="text--secondary">
                  {{ row.old }}
                </td>
                <td class="primary--text">
                  {{ row.new }}
                </td>
              </tr>
            </tbody>
          </v-simple-table>
          <div
            v-if="newImages.length"
            class="mt-4"
          >
            <p class="mb-1">
              ຮູບໃໝ່ (ຈະແທນຮູບເກົ່າທັງໝົດ):
            </p>
            <a
              v-for="img in newImages"
              :key="img.id"
              :href="img.original_url || img.url"
              target="_blank"
            >
              <v-avatar
                class="mr-2 rounded"
                size="96px"
              >
                <img :src="img.original_url || img.url">
              </v-avatar>
            </a>
          </div>
          <v-textarea
            v-model="rejectReason"
            class="mt-4"
            label="ເຫດຜົນ (ຕ້ອງໃສ່ເມື່ອປະຕິເສດ)"
            rows="2"
            outlined
            :error-messages="rejectError"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="detailDialog = false"
          >
            ປິດ
          </v-btn>
          <v-spacer />
          <v-btn
            color="error"
            text
            :loading="loading"
            :disabled="loading || !detailLoaded"
            @click="reject()"
          >
            ປະຕິເສດ
          </v-btn>
          <v-btn
            color="success"
            :loading="loading"
            :disabled="loading || !detailLoaded"
            @click="approve()"
          >
            ອະນຸມັດ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { changeRows } from './editFields';

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Edit Approval';
  },
  data() {
    return {
      items: [],
      filter: '',
      offset: 12,
      pagination: {},
      requestSeq: 0,
      vehicleNames: {},
      loading: false,
      detailDialog: false,
      detailLoaded: false,
      selected: null,
      rejectReason: '',
      rejectError: '',
      headers: [
        { text: 'ລະຫັດ', value: 'customer_id' },
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ຜູ້ສົ່ງ', value: 'submitter', sortable: false },
        { text: 'ວັນທີສົ່ງ', value: 'created_at' },
        { text: '', value: 'action', sortable: false },
      ],
    };
  },
  computed: {
    rows() {
      if (!this.selected) return [];
      return changeRows(this.selected.diff || {}, { ...(this.selected.labels || {}), vehicles: this.vehicleNames });
    },
    newImages() {
      return (this.selected && this.selected.media) || [];
    },
  },
  created() {
    this.fetchData();
    this.$axios.get('vehicle_type/')
      .then((res) => {
        this.vehicleNames = Object.fromEntries(res.data.data.map((v) => [v.id, v.name]));
      })
      .catch(() => {});
  },
  methods: {
    fetchData(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.requestSeq;
      if (page) this.$set(this.pagination, 'current_page', page);
      this.$store.commit('Loading_State', true);
      this.$axios
        .get('company-edit-request/pending', {
          params: {
            page: this.pagination.current_page,
            per_page: 20,
            filter: this.filter || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.items = res.data.data.data;
          this.pagination = res.data.data.pagination;
        })
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
    openDetail(item) {
      // The diff against the company's current values comes from the detail call.
      this.selected = item;
      this.detailLoaded = false;
      this.rejectReason = '';
      this.rejectError = '';
      this.detailDialog = true;
      this.$axios.get(`company-edit-request/${item.id}`).then((res) => {
        if (this.selected && this.selected.id === item.id) {
          this.selected = res.data.data;
          this.detailLoaded = true;
        }
      });
    },
    approve() {
      this.review(`company-edit-request/${this.selected.id}/approve`, {});
    },
    reject() {
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.rejectError = 'ກະລຸນາໃສ່ເຫດຜົນທີ່ປະຕິເສດ';
        return;
      }
      this.review(`company-edit-request/${this.selected.id}/reject`, { reason: this.rejectReason.trim() });
    },
    review(url, body) {
      this.loading = true;
      this.$axios
        .post(url, body)
        .then((res) => {
          this.$store.commit('Toast_State', { value: true, color: 'success', msg: res.data.message });
          this.detailDialog = false;
          this.fetchData();
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          // 422 from approve: phone/name/location taken by another customer since it was sent.
          const details = data.errors ? Object.values(data.errors).map((m) => (Array.isArray(m) ? m[0] : m)).join(' ') : '';
          this.$store.commit('Toast_State', {
            value: true,
            color: 'error',
            msg: [data.message || 'Something went wrong', details].filter(Boolean).join(' — '),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
